export function PageHeader({ eyebrow, title, subtitle, badge, actions }) {
  return (
    <div className="flex flex-col gap-3 border-b border-slate-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <div className="mb-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-[#1a5fd0]">
            {eyebrow}
          </div>
        )}
        <div className="flex items-center gap-3">
          <h1 className="font-head text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
          {badge}
        </div>
        {subtitle && <p className="mt-2 max-w-2xl text-sm text-slate-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div
      className={`rounded-xl border border-slate-200 bg-white transition-shadow hover:shadow-[0_1px_20px_-8px_rgba(15,23,42,0.15)] ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ icon: Icon, children, tone = "#1a5fd0" }) {
  return (
    <div className="mb-3 flex items-center gap-2">
      {Icon && <Icon size={15} style={{ color: tone }} />}
      <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500">{children}</h3>
    </div>
  );
}
